import { http } from '../../core';
import Config from "../../app.config";
const RequestbaseURL = http.create({ baseURL: Config.BASE_API });

export function addEvent(params) {
  return RequestbaseURL.post('/fault/v1/event/add', params)
}

export function filterUser(params) {
  return RequestbaseURL.post('/wechat/v1/user_list', { name: params })
}

export function levelList() {
  return RequestbaseURL.get('/fault/v1/level/list')
}

export function discoveryList() {
  return RequestbaseURL.get('/fault/v1/discovery/list')
}

export function addCategory(params) {
  return RequestbaseURL.post('/fault/v1/category/add', params)
}

export function categoryList(params) {
  return RequestbaseURL.get('/fault/v1/category/list', params)
}

export function categoryChildren(params) {
  return RequestbaseURL.get('/fault/v1/category/children', params)
}
